/**
 * advert config — конфигурация баннеров (PUID, pad, коды, стили)
 */

export const SHOW_ANY_ADV = process.env.SHOW_ANY_ADV === 'true'

export const DEFAULT_AD_TYPE = '100%x240'

// типы баннеров, для которых не показывается заглушка PlugAds
export const AD_TYPES_WITHOUT_PLUG: string[] = ['Billboard', 'TopBanner']

export const DEV_MODE_URL_PARAM = 'is_dev=true'

export const PUID = {
  afisha_6: 'AFISHARU_MAIN',
  afisha_18: 'AFISHARU_MAIN_MAIN',
  rests_6: 'AFISHA_RESTAURANTS',
  rests_18: 'AFISHA_RESTAURANTS_MAIN',
}

const pad_1 = 432499134
const pad_2 = 545711485

export type AdvertInlineStyle = {
  minWidth: string
  maxWidth: string
  minHeight: string
  maxHeight: string | null
}

export type AdvertConfigEntry = { code: [number, number]; scrollLoad: boolean; style: AdvertInlineStyle }

export const ADVERT_CONFIG: Record<string, AdvertConfigEntry> = {
  Billboard: {
    code: [pad_1, 432499160],
    scrollLoad: false,
    style: { minWidth: '100%', maxWidth: '100%', minHeight: '120px', maxHeight: '120px' },
  },
  TopBanner: {
    code: [pad_2, 579500508],
    scrollLoad: false,
    style: { minWidth: '100%', maxWidth: '100%', minHeight: '120px', maxHeight: '120px' },
  },
  '100%x240': {
    code: [pad_1, 432499144],
    scrollLoad: true,
    style: { minWidth: '920px', maxWidth: '1232px', minHeight: '300px', maxHeight: '400px' },
  },
  '240x400': {
    code: [pad_1, 432499154],
    scrollLoad: true,
    style: { minWidth: '300px', maxWidth: '300px', minHeight: '600px', maxHeight: null },
  },
  '240x400_2nd': {
    code: [pad_1, 432499148],
    scrollLoad: true,
    style: { minWidth: '300px', maxWidth: '300px', minHeight: '600px', maxHeight: null },
  },
  'Context_100%x70': {
    code: [pad_1, 438040176],
    scrollLoad: true,
    style: { minWidth: '200px', maxWidth: '1232px', minHeight: '200px', maxHeight: '400px' },
  },
  Context_full: {
    code: [pad_1, 438040176],
    scrollLoad: true,
    style: { minWidth: '920px', maxWidth: '1232px', minHeight: '300px', maxHeight: null },
  },
  Content1: {
    code: [pad_2, 545711495],
    scrollLoad: true,
    style: { minWidth: '920px', maxWidth: '1232px', minHeight: '300px', maxHeight: null },
  },
  Content2: {
    code: [pad_2, 545711501],
    scrollLoad: true,
    style: { minWidth: '920px', maxWidth: '1232px', minHeight: '300px', maxHeight: null },
  },
  Content3: {
    code: [pad_2, 545716147],
    scrollLoad: true,
    style: { minWidth: '920px', maxWidth: '1232px', minHeight: '300px', maxHeight: null },
  },
  Content4: {
    code: [pad_2, 545722549],
    scrollLoad: true,
    style: { minWidth: '920px', maxWidth: '1232px', minHeight: '300px', maxHeight: null },
  },
  Footer: {
    code: [pad_2, 545731421],
    scrollLoad: true,
    style: { minWidth: '320px', maxWidth: '1600px', minHeight: '250px', maxHeight: null },
  },
  Listing1: {
    code: [pad_2, 545735133],
    scrollLoad: true,
    style: { minWidth: '320px', maxWidth: '1600px', minHeight: '250px', maxHeight: null },
  },
  Listing2: {
    code: [pad_2, 545735171],
    scrollLoad: true,
    style: { minWidth: '320px', maxWidth: '1600px', minHeight: '250px', maxHeight: null },
  },
  Listing3: {
    code: [pad_2, 545735399],
    scrollLoad: true,
    style: { minWidth: '320px', maxWidth: '1600px', minHeight: '250px', maxHeight: null },
  },
  Listing4: {
    code: [pad_2, 545735901],
    scrollLoad: true,
    style: { minWidth: '320px', maxWidth: '1600px', minHeight: '250px', maxHeight: null },
  },
  Center: {
    code: [pad_1, 579502505],
    scrollLoad: true,
    style: { minWidth: '200px', maxWidth: '200px', minHeight: '200px', maxHeight: '200px' },
  },
  Parallax: {
    code: [pad_1, 579502503],
    scrollLoad: true,
    style: { minWidth: '920px', maxWidth: '1232px', minHeight: '300px', maxHeight: null },
  },
}

export type TypeAd = keyof typeof ADVERT_CONFIG

export const getCurrentCode = (typeCurrent: string, _isMobile: boolean | null = null) =>
  ADVERT_CONFIG[typeCurrent as TypeAd]?.code

export const getCurrentScrollLoad = (typeCurrent: string, _isMobile: boolean | null = null) =>
  ADVERT_CONFIG[typeCurrent as TypeAd]?.scrollLoad

export const getInlineStyles = (typeCurrent: string) => ADVERT_CONFIG[typeCurrent]?.style ?? {}
